module.exports = __webpack_public_path__ + "static/media/maximize.efa60513.svg";